// @flow weak

import { connect }              from 'react-redux';
import {
  bindActionCreators,
  compose
}                               from 'redux';
import { withRouter }           from 'react-router';
import userInfosActions    from '../../redux/modules/userInfos';
import * as sidemenuActions     from '../../redux/actions/sideMenu';
import * as earningGraphActions from '../../redux/modules/earningGraph';
import App                      from './App';
import { userActions } from '../../redux/actions/user';

const mapStateToProps = (state) => {
 
  return {
    sideMenuIsCollapsed: state.sideMenu.isCollapsed
  };
};



const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        ...sidemenuActions,
        ...userActions
      },
      dispatch
    )
  };
};

// we use here compose (from redux) just for conveniance (since compose(f,h, g)(args) looks better than f(g(h(args))))
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps,mapDispatchToProps)
)(App);



// WEBPACK FOOTER //
// ./src/app/containers/app/index.js